import { render, staticRenderFns } from "./DeliveryRequestSearchInfo.vue?vue&type=template&id=506aeceb&scoped=true&lang=pug&"
import script from "./DeliveryRequestSearchInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryRequestSearchInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryRequestSearchInfo.vue?vue&type=style&index=0&id=506aeceb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506aeceb",
  null
  
)

export default component.exports